// extracted by mini-css-extract-plugin
export default {"input":"CompleteCompanyNameModal_input__I2sV4"};